import { render, staticRenderFns } from "./PermissionsList.vue?vue&type=template&id=46884e47&scoped=true"
import script from "./PermissionsList.vue?vue&type=script&lang=js"
export * from "./PermissionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46884e47",
  null
  
)

export default component.exports